<template>
    <div class="pb-2">
        <div class="tabs">
            <div class="flex border-b border-gray-200 overflow-x-auto scrolling-touch mb-8">
                <button
                    v-for="tab in tabs"
                    :key="tab.name"
                    class="tab"
                    :class="{ 'active': tab.isActive, 'border-red-600': tab.hasErrors }"
                    @click.prevent="updateActive(tab)"
                >
                    {{ tab.name }}
                </button>

                <div class="flex-shrink-0 w-8 min-h-full"></div>
            </div>
        </div>

        <div class="tab-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Tabs',

    data() {
        return {
            tabs: [],
        };
    },

    created() {
        this.tabs = this.$children;

        this.$events.$on('update-active-tab', (tab) => {
            this.updateActive(tab);
        });

        this.$events.$on('next-tab', (tab) => {
            this.nextTab(tab);
        });

        this.$events.$on('prev-tab', (tab) => {
            this.prevTab(tab);
        });
    },

    methods: {
        updateActive(targetTab) {
            this.tabs.forEach((tab) => {
                tab.isActive = (tab.name === targetTab.name);
            });
        },

        nextTab() {
            let activeIndex = 0;

            this.tabs.forEach((tab, index) => {
                if (tab.isActive) {
                    activeIndex = index;
                    tab.isActive = false;
                }
            });

            this.tabs[activeIndex + 1].isActive = true;
        },

        prevTab() {
            let activeIndex = 0;

            this.tabs.forEach((tab, index) => {
                if (tab.isActive) {
                    activeIndex = index;
                    tab.isActive = false;
                }
            });

            this.tabs[activeIndex - 1].isActive = true;
        },
    },
};

</script>
